module.exports = __webpack_public_path__ + "img/u52.937b590d.png";